<template>
  <div class="field">
    <div class="control">
      <select-wrapper
        :options="bundles"
        @input="update"
        placeholder="Selecteer de bundel waaruit de datasets geimporteerd moeten worden">
      </select-wrapper>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SelectWrapper from '@/components/wrappers/SelectWrapper'

export default {
  name: 'ImportFromBundle',
  components: {
    SelectWrapper
  },
  computed: {
    ...mapGetters({
      account: 'account/account'
    }),
    bundles () {
      return this.account.bundles.map((bundle) => {
        return {
          label: bundle.name,
          value: bundle.id
        }
      })
    }
  },
  methods: {
    update (payload) {
      this.$emit('importfrombundle:changed', { key: 'from', value: payload })
    }
  }
}
</script>

<style scoped>
.modal-content {
  min-height: 25%;
}

.box {
  height: 100%;
}
</style>
